<template>
    <!--suppress ES6ModulesDependencies -->
    <Dialog :value="autenticar" :title="title" width="350">
        <v-layout>
            <v-flex>
                <v-label>Login: {{ login }}</v-label>
                <m-form ref="form" class="pt-4" @submit.prevent="enviar">
                    <m-text-field ref="input"
                                  :label="label"
                                  class="required"
                                  :type="pass_visible ? 'text' : 'password'"
                                  v-model="senha"
                                  :rules="[$rules.required]"
                                  maxlength="100"
                                  outlined
                                  autocomplete="disabled">
                        <div slot="prepend-inner">
                            <v-icon color="primary">ol-lock</v-icon>
                        </div>
                        <v-icon slot="append" @click="pass_visible = !pass_visible"
                                :color="pass_visible ? 'primary' : 'darkgray'">
                            ol-visibility
                        </v-icon>
                    </m-text-field>
                </m-form>
            </v-flex>
        </v-layout>
        <v-layout slot="buttons">
            <v-flex>
                <v-btn class="btn-default" color="primary" @click="enviar">{{ btn_enviar }}</v-btn>
            </v-flex>
        </v-layout>
    </Dialog>
</template>

<script>
  import { mapMutations, mapState } from 'vuex'
  import { autenticar } from '../webservice/autenticar'
  import { notification, sleep } from '../plugins/helpers'

  export default {
    name: 'DialogAtualizarSenha',
    data: () => ({
      senha: '',
      pass_visible: false
    }),
    computed: {
      ...mapState(['autenticar', 'senha_invalida', 'retry_resolvers', 'login']),
      title () {
        return this.senha_invalida ? 'ATUALIZAR SENHA' : 'SESSÃO EXPIRADA'
      },
      label () {
        return this.senha_invalida ? 'Nova senha' : 'Confirmar senha'
      },
      btn_enviar () {
        return this.senha_invalida ? 'ATUALIZAR' : 'ENVIAR'
      }
    },
    watch: {
      autenticar (open) {
        if (open) {
          this.$nextTick(() => {
            this.$refs.form.reset()
            this.focus()
          })
        } else {
          this.$http.get('/proposta/sincronizar_job', { options: { silent: true }, requestId: false })
        }
      }
    },
    mounted () {
      if (this.autenticar) {
        this.focus()
      }
    },
    methods: {
      ...mapMutations(['setAutenticar']),
      enviar () {
        const form = this.$refs.form
        if (form.validate()) {
          const login = this.login
          const senha = this.senha

          autenticar(login, senha)
            .then(() => {
              this.retry_resolvers.forEach(p => p.resolve())
              this.setAutenticar(false)
            })
            .catch(err => {
              notification('error', err, 'Não foi possível autenticar.')
            })
        }
      },
      fechar () {
        this.retry_resolvers.forEach(p => p.reject())
        this.setAutenticar(false)
      },
      focus () {
        sleep(100).then(() => {
          this.$refs.input.focus()
        })
      }
    }
  }
</script>

<style scoped>

</style>
